import cookie from 'react-cookies';

import axios from 'axios';

import { apiBaseUrl } from './api';

export const changePhone = async ({ phone }) => {
  const token = cookie.load('lendistry_tokens_access');
  return axios.post(
    `${apiBaseUrl}/account/user/phone`,
    { phone },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const signOut = async () => {
  const token = cookie.load('lendistry_tokens_access');
  return axios.post(
    `${apiBaseUrl}/account/signout`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const changeEmail = async ({ email }) => {
  const token = cookie.load('lendistry_tokens_access');
  return axios.post(
    `${apiBaseUrl}/account/user/email`,
    { email },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const phoneVerificationManageProfile = async ({ intentId, code }) => {
  const token = cookie.load('lendistry_tokens_access');
  return axios.post(
    `${apiBaseUrl}/account/user/phone-verification`,
    { intentId, code },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const phoneVerificationManageProfileResendCode = async ({ intent }) => {
  const token = cookie.load('lendistry_tokens_access');
  return axios.post(
    `${apiBaseUrl}/account/user/phone-verification/resend-code`,
    { intent },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
